export const toastTimeoutTime = 10000;

export const poweredByHiver = 'kb-website-powered-by-hiver';

export const customizeNavigationButton = 'ftr-kb-customize-navigation-button';
export const FTR_KB_FOR_OUTLOOK = 'ftr-kb-for-outlook';
export const FTR_SUB_CATEGORIES = 'ftr-kb-subcategories';

export const FTR_KB_NEW_LOGIN = 'ftr-kb-new-login';
/** UG-scoped: send force_login=1 on v2 login/init to always get a Google OAuth URL */
export const FTR_KB_LOGIN_FORCE_OAUTH = 'ftr-kb-login-force-oauth';
export const FTR_KB_NEW_UI = 'rls-kb-new-ui';
export const FTR_KB_AI_SEARCH = 'rls-kb-ai-search';
export const FTR_KB_AI_SEARCH_CONTINUE_CONVERSATION = 'rls-kb-ai-search-continue-conversation';

export const PRODUCT_KB_ORIGIN = 'https://help.hiverhq.com';
